import { render, staticRenderFns } from "./SettlementRequests.vue?vue&type=template&id=18d4eaa8"
import script from "./SettlementRequests.vue?vue&type=script&lang=js"
export * from "./SettlementRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports